// extracted by mini-css-extract-plugin
module.exports = {"spinner":"Spinner_spinner__rZ2Dn","circle-rotate":"Spinner_circle-rotate__xll3h","dash":"Spinner_dash__tJiJU","circle-dash":"Spinner_circle-dash__As44B"};